import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';

import { PdpSharedDetail, PdpSharedDetailProps } from './PdpSharedDetail';
import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';
import { Link } from 'dibs-elements/exports/Link';

import { PdpSharedDetailFramingOptions_item$data as Item } from './__generated__/PdpSharedDetailFramingOptions_item.graphql';
import { PdpSharedDetailFramingOptions_user$data as User } from './__generated__/PdpSharedDetailFramingOptions_user.graphql';

type Props = PdpSharedDetailProps & {
    item: Item;
    user: User;
};

const PdpSharedDetailFramingOptionsComponent: FC<Props> = ({ item, user, ...props }) => {
    const trackingLabel = 'framing options';

    return (
        <>
            <PdpSharedDetail {...props} />
            <SharedContactDealerWrapper
                item={item}
                launchOrigin={trackingLabel}
                user={user}
                currency={props.currency}
            >
                {(onClick: () => void) => (
                    <Link onClick={onClick} dataTn="item-details-framing-options-contact-gallery">
                        <FormattedMessage
                            id="abf.pdp.framingOptionsContactGalleer"
                            defaultMessage="Contact Gallery"
                        />
                    </Link>
                )}
            </SharedContactDealerWrapper>
        </>
    );
};

export const PdpSharedDetailFramingOptions = createFragmentContainer(
    PdpSharedDetailFramingOptionsComponent,
    {
        item: graphql`
            fragment PdpSharedDetailFramingOptions_item on Item {
                ...SharedContactDealerWrapper_item
            }
        `,
        user: graphql`
            fragment PdpSharedDetailFramingOptions_user on User {
                ...SharedContactDealerWrapper_user
                serviceId
            }
        `,
    }
);
